import clsx from "clsx"
import { FC } from "react"
import { Ton3dIcon } from "@/assets"
import { Button } from "@/ui/Button"
import styles from "./DepositPresetChip.module.scss"
import { IDepositPresetChip } from "./types"

export const DepositPresetChip: FC<IDepositPresetChip> = ({
  amount,
  isActive,
  onClick,
  className,
  ...rest
}) => {
  return (
    <Button
      {...rest}
      className={clsx(
        styles.DepositPresetChip,
        { [styles.active]: isActive },
        className
      )}
      onClick={onClick}
    >
      <Ton3dIcon className={styles.DepositPresetChip_icon} />
      {/* "TON" is a brand ticker — intentionally not localized */}
      <div className={styles.DepositPresetChip_amount}>
        {amount} <span className={styles.DepositPresetChip_unit}>TON</span>
      </div>
    </Button>
  )
}
